const celebritiesSlug = Object.freeze({
  GREG_LOUGANIS: 'greg-louganis',
  MICHAEL_BEASLEY: 'michael-beasley',
  ASHLEY_GREENE: 'ashley-greene',
});

export default celebritiesSlug;
